<script lang="ts">
import ClientStateFilterList from '../components/ClientStateFilterList.vue';

/** Certificates list. Client-side state filtering - see ClientStateFilterList. */
export default { name: 'ListCertManagerCertificate', extends: ClientStateFilterList };
</script>
